module.exports = __webpack_public_path__ + "img/gift1.905a18ca.png";